<template>
	<el-dialog
	  :title="type==1?'发布新帖':'修改帖子'"
	  :visible.sync="dialogVisible"
	  width="60%" top="2vh">
	  <uploadimg @upload="uploadddd" ref="uploadFileClick" style="display: none;"></uploadimg>
	  <el-form :model="dataForm" ref="dataForm" :rules="rules">
		  <el-form-item label="专题" prop="zhuantiid" v-if="xianshi==0" label-width="100px">
			  <el-select v-model="dataForm.zhuantiid" placeholder="请选择">
			     <el-option
			       v-for="item in zhuanti"
			       :key="item.id"
			       :label="item.title"
			       :value="item.id">
			     </el-option>
			   </el-select>
		  </el-form-item>
		  <el-form-item label="帖子标题" prop="title" label-width="100px">
			  <el-input placeholder="请输入标题" v-model="dataForm.title"></el-input>
		  </el-form-item>
		  <el-form-item label="是否精华贴" prop="jinghua" label-width="100px">
		  	 <el-radio v-model="dataForm.jinghua" :label="1">是</el-radio>
			 <el-radio v-model="dataForm.jinghua" :label="2">否</el-radio>
		  </el-form-item>
		  <el-form-item label="帖子内容" prop="content" label-width="100px">
		  	 <mavonEditor
		  	 		 v-model="dataForm.content" 
		  	 		 ref="md"
		  	 		 @imgAdd="handleEditorImgAdd"
		  	 		 style="height: 400px;" />
		  	 </el-form-item>
		  </el-form-item>
		  <el-form-item label="" label-width="100px">
			  <el-button @click="dialogVisible=false">取消</el-button>
			  <el-button type="success" @click="save">确认发布</el-button>
		  </el-form-item>
	  </el-form>
	</el-dialog>
</template>

<script>
	import { zhuanti_list,user_save_tiezi } from "@/api/boke"
	import uploadimg from "@/common/ImgUpload.vue"
		import { uploadOss } from "@/api/config"
	export default{
		components:{
			uploadimg
		},
		data(){
			let that = this;
			return{
				type:1,
				xianshi:0,
				dialogVisible:false,
				dataForm:{
					id:null,
					zhuantiid:'',
					title:'',
					content:'',
					jinghua:2
				},
				rules:{
					zhuantiid:[{ required: true, message: '请选择专题', trigger: 'blur' }],
					title:[{ required: true, message: '标题必填', trigger: 'blur' }],
					content:[{ required: true, message: '内容必填', trigger: 'blur' }],
					jinghua:[{ required: true, message: '必选', trigger: 'blur' }],
				},
				zhuanti:[],//专题

			}
		},
		watch:{
			dialogVisible(e){
				if(e==false){
					this.dataForm = {
						id:null,
						zhuantiid:'',
						title:'',
						content:'',
						jinghua:2
					}
					this.xianshi = 0
				}
			},
		},
		mounted(){
			
		},
		methods:{
			handleEditorImgAdd(pos,file){
				console.log("添加图片");
				let that = this;
				console.log("pos",pos);
				console.log("file",file);
				var formdata = new FormData();
				formdata.append("file", file);
				const loading = this.$loading({
						lock: true,
						text: '上传中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
				});
				uploadOss(formdata).then(res=>{
					loading.close();
					this.$refs.md.$img2Url(pos, res.data);
				}).catch(()=>{
					loading.close();
				})
			},
			handlecreate(type,info,xianshi){
				this.type = type
				this.dialogVisible = true
				this.xianshi = xianshi?1:0
				if(info){
					this.dataForm.zhuantiid = info.zhuantiid
				}
				if(type==2){
					this.dataForm = {
						id:info.id,
						zhuantiid:info.zhuantiid,
						title:info.title,
						content:info.content,
						jinghua:info.jinghua
					}
				}
				this.zhuanti_list();
			},
			//提交方法
			async save(){
			  let that = this;
			  that.$refs['dataForm'].validate((valid) => {
			    if (valid) {
			        const loading = this.$loading({
			            lock: true,
			            text: '发布中',
			            spinner: 'el-icon-loading',
			            background: 'rgba(0, 0, 0, 0.7)'
			          });
			         user_save_tiezi(this.dataForm).then((res)=>{
						 loading.close();
						 this.$message.success("发布成功");
						 console.log("发布成功",res.data);
						 this.dialogVisible = false
						 this.$emit("succ",res.data.id);
					 }).catch(()=>{
						 loading.close();
					 })
			    } else {
			      console.log("error");
			    }
			  })
			},
			zhuanti_list(){
				zhuanti_list({}).then(res=>{
					this.zhuanti = res.data
				})
			},
		},
	}
</script>

<style lang="scss">
	.ql-container {
	    height: 300px;
	  }
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/components/save.vue